import { extend, override } from 'flarum/common/extend';
import WelcomeHero from 'flarum/forum/components/WelcomeHero';
import app from 'flarum/forum/app';

export default function () {
  extend(WelcomeHero.prototype, 'view', function (vnode) {
    if (!app.forum.attribute('welcomeBannerUrl') || !(vnode && typeof vnode === 'object' && 'attrs' in vnode)) {
      return;
    }

    vnode.attrs.className += ' BannerHero';
    vnode.attrs.style = vnode.attrs.style || {};
    vnode.attrs.style['--banner-url'] = `url(${app.forum.attribute('welcomeBannerUrl')})`;
    vnode.attrs.onclick = () => {
      const link = app.forum.attribute('welcomeBannerLink');
      if (link && typeof link === 'string') {
        window.open(link);
      }
    };
  });

  override(WelcomeHero.prototype, 'isHidden', function (isHidden: any) {
    if (app.forum.attribute('welcomeBannerUrl')) {
      return false;
    }
    return isHidden();
  });
}
